export default __webpack_public_path__ + "static/media/thumbnail.58feea8d.jpg";